import _memoize from 'lodash/memoize';
import { Lightning } from '@lightningjs/sdk';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { identity, middle } from '../../../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { STORYBOARD_HEIGHT } from './storyboard/storyboard.style';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 30,
  [FULL_HD]: 36,
};

// Distance between elapsed/duration labels and bar start/end
export const LABEL_OFFSET = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const BAR_HEIGHT_UNFOCUSED = {
  [HD]: 8,
  [FULL_HD]: 8,
};

export const BAR_HEIGHT_FOCUSED = {
  [HD]: 12,
  [FULL_HD]: 12,
};

export const STORYBOARD_OFFSET_BOTTOM = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
  adMarker: makeThemeColor(PRIMARY),
};

export const AD_MARKER_HEIGHT = 12;

export const AD_MARKER_WIDTH = 6;

export const AD_MARKER_BORDER_RADIUS = 2;

export const SLIDER_THUMB_TRANSITION = { duration: 0.3, timingFunction: 'linear' };

export const getTimeLabelsFont = screenSize => getFont(FONT.BERLIN_1, screenSize);

export const makeTextStyle = ({ screenSize, colorMode }) => ({
  color: colors.text[colorMode],
  mountY: 0.5,
  y: middle,
  text: {
    ...getTimeLabelsFont(screenSize),
    verticalAlign: 'middle',
  },
});

export const makeAdMarkerStyle = ({ colorMode }) => ({
  rect: true,
  w: AD_MARKER_WIDTH,
  h: AD_MARKER_HEIGHT,
  color: colors.adMarker[colorMode],
  shader: {
    type: Lightning.shaders.RoundedRectangle,
    radius: AD_MARKER_BORDER_RADIUS,
  },
});

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const elapsedStyle = makeTextStyle(context);
  elapsedStyle.text.textAlign = 'right';

  return {
    Elapsed: elapsedStyle,
    Bar: {
      mountY: 0.5,
      x: LABEL_OFFSET[screenSize],
      y: middle,
      h: BAR_HEIGHT_UNFOCUSED[screenSize],
    },
    Ads: {
      h: AD_MARKER_HEIGHT,
    },
    Duration: {
      ...makeTextStyle(context),
      x: identity,
      mountX: 1,
    },
    SliderThumb: {
      y: middle,
      mount: 0.5,
      scale: 0,
    },
    Storyboard: {
      y: -STORYBOARD_HEIGHT - STORYBOARD_OFFSET_BOTTOM[screenSize],
    },
  };
};

export const getUnFocusedStyle = _memoize(screenSize => ({
  Bar: {
    smooth: {
      h: BAR_HEIGHT_UNFOCUSED[screenSize],
    },
  },
  SliderThumb: {
    smooth: {
      scale: 0,
    },
  },
}));

export const getFocusedStyle = _memoize(screenSize => ({
  Bar: {
    smooth: {
      h: BAR_HEIGHT_FOCUSED[screenSize],
    },
  },
  SliderThumb: {
    smooth: {
      scale: 1,
    },
  },
}));
